export const aggregateOr = ({ scope, values }) => {
  let isValid = false;
  scope.forEach((item) => {
    if (!isValid && values[item]) {
      isValid = values[item];
    }
  });
  return isValid;
};

export const checkSum = ({ scope, values, minValue, maxValue }) => {
  let sum = 0;

  scope.forEach((item) => {
    if (typeof item === "string") {
      sum += Number(values[item]);
    } else if (!!item && typeof item === "object") {
      sum += Object.entries(item).some(
        ([key, expected]) => values[key] === expected,
      )
        ? 1
        : 0;
    }
  });

  return !(sum < minValue || sum > maxValue);
};

export const checkIsValid = ({ constraints, values }) => {
  const result = {
    isValid: true,
    messages: [],
  };

  constraints.forEach((constraint) => {
    const { minValue, maxValue, reference, scope, warningMessage } = constraint;
    switch (reference) {
      case "aggregateOr":
        {
          const isValid = aggregateOr({ scope, values });
          if (!isValid) {
            result.isValid = false;
            result.messages.push(warningMessage);
          }
        }
        return;
      case "sum":
        {
          const isValid = checkSum({
            scope,
            values,
            minValue,
            maxValue,
          });
          if (!isValid) {
            result.isValid = false;
            result.messages.push(warningMessage);
          }
        }
        return;
      default:
        console.warn("No function provided for that rule");
    }
  });

  return result;
};
